import "./styles.css";
export default function Logo() {
  return (
    <div className={"Logo"}>
      <h3>The Calving Book</h3>
      <span>PLUS</span>
    </div>
  );
}
